/**
 * Reisdagboek (§16) — chronologische lijst van gekozen houdingen en reflectie-
 * antwoorden, met chakra-kleur per entry. (Fase 5 verfijnt de presentatie.)
 */
import { HEADERS } from '../data/headers';
import { useProgressStore } from '../store/progressStore';
import { t, type Taal } from '../i18n';

interface Props {
  taal: Taal;
  onTerug: () => void;
}

export function Reisdagboek({ taal, onTerug }: Props) {
  const entries = useProgressStore((s) => s.reisdagboek);

  return (
    <div className="mandala-textuur flex h-full w-full flex-col bg-achtergrond text-slate-100">
      <div className="flex items-center justify-between border-b border-white/10 px-4 py-2">
        <h2 className="text-lg font-bold" style={{ fontFamily: 'Cinzel, serif', color: '#c9a86a' }}>{t('ui.reisdagboek', taal)}</h2>
        <button type="button" onClick={onTerug} className="rounded border border-white/15 px-3 py-1 text-sm hover:bg-white/5">← {t('ui.terug', taal)}</button>
      </div>

      <div className="flex-1 overflow-y-auto p-4">
        {entries.length === 0 ? (
          <p className="mt-10 text-center text-sm text-slate-500">{t('ui.reisLeeg', taal)}</p>
        ) : (
          <ul className="mx-auto flex max-w-2xl flex-col gap-2">
            {entries.map((e, i) => {
              const kleur = HEADERS[e.chakra].accent;
              return (
                <li key={i} className="flex gap-3 rounded-lg border border-white/10 p-3" style={{ background: `${HEADERS[e.chakra].kleur}11` }}>
                  <span className="mt-1 h-2 w-2 shrink-0 rounded-full" style={{ background: kleur }} />
                  <div>
                    <div className="text-[11px] uppercase tracking-wide text-slate-500">{HEADERS[e.chakra].naam} · {e.baasNaam} · {e.soort}</div>
                    <div className="text-sm text-slate-200" style={{ fontFamily: 'EB Garamond, serif' }}>{e.tekst}</div>
                  </div>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </div>
  );
}
